import React, { ChangeEvent, useEffect, useState } from 'react';
import { Box, TextField } from '@material-ui/core';

import { ModalBody, ModalHeader, Modal } from '../../../../components/Modais/styles';
import { Flex } from '../../../../components/NavBar/styles';
import Botao from '../../../../components/Botoes/Botao';
import InputNumero from '../../../../components/InputNumero';
import Select from '../../../../components/Select';
import useStore from '../../../../services/hooks/useStore';
import { Insumo } from '../../../../@types/Insumo';
import { getThingsV2 } from '../../../../services/utils';

type Form = {
  categoria: SelectRow | null;
  insumo: SelectRow | null;
  unidade: string;
  descricao: string;
  valorTotal: number;
  quantidade: number;
  valorUnitario: number;
};

type DespesaItemRacao = DespesaItemCriacao & {
  insumo: number;
};

type Props = {
  open: boolean;
  handleClose: () => void;
  handleAdd: (dados: DespesaItemRacao) => void;
  handleUpdate: (id: number, dados: DespesaItemRacao) => void;
  item: DespesaItemRacao | null;
  categoria: string;
  valorFrete?: number;
  outrosValores?: number;
  tipoCategoria?: string;
};

export function ModalCompraInsumoItem({
  open,
  handleClose,
  handleAdd,
  handleUpdate,
  item,
  categoria,
  tipoCategoria,
}: Props) {
  const store = useStore();
  const [sync, setSync] = useState(false);
  const [insumos, setInsumos] = useState<Insumo[]>([]);
  const categoriasOptions = store.categorias.getByTipo(tipoCategoria ?? 'despesas').map((categoria) => {
    return { label: categoria.nome, value: categoria.id };
  });

  const defaultCategoriaId = Number(categoria) || null;
  const categoriaDefault = categoriasOptions.find((cat) => cat.value === defaultCategoriaId) || null;
  const defaultForm: Form = {
    categoria: categoriaDefault,
    insumo: null,
    unidade: '',
    descricao: '',
    quantidade: 0,
    valorTotal: 0,
    valorUnitario: 0,
  };
  const initialForm: Form = item
    ? {
      categoria: null,
      insumo: null,
      unidade: '',
      descricao: item.descricao,
      quantidade: item.quantidade,
      valorTotal: item.valor_total_item,
      valorUnitario: item.valor_uni_item,
    }
    : defaultForm;
  const [form, setForm] = useState<Form>(initialForm);

  function handleSubmit() {
    if (!form.insumo) store.notificar('Informe o Insumo');
    if (!form.categoria) store.notificar('Informe a categoria');
    else if (!form.descricao) store.notificar('Informe a descrição');
    else if (!form.quantidade || form.quantidade <= 0) store.notificar('Informe a quantidade');
    else if (!form.valorTotal || form.valorTotal <= 0) store.notificar('Informe o valor total');
    else if (!form.valorUnitario || form.valorUnitario <= 0)
      store.notificar('Não foi possível calcular o valor unitário');
    else {
      const dados: DespesaItemRacao = {
        id: item ? item.id : new Date().getTime(),
        categoria: form.categoria?.value,
        descricao: form.descricao,
        quantidade: form.quantidade,
        valor_uni_item: form.valorUnitario,
        valor_total_item: form.valorTotal,
        valor_total: 0,
        valor_unitario: 0,
        valor_outros_item: 0,
        valor_frete_item: 0,
        insumo: parseInt(form.insumo!.value),
      };

      if (item) handleUpdate(item.id, dados);
      else handleAdd(dados);

      handleClose();
    }
  }

  function updateFormEvent(e: ChangeEvent<HTMLInputElement>) {
    const { name, value } = e.target;
    if (name) {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  }

  useEffect(() => {
    setSync(true);
  }, []);

  useEffect(() => {
    setForm(initialForm);
  }, [open]);

  useEffect(() => {
    if (item) {
      const categoria = categoriasOptions.find((cat) => cat.value === item.categoria.id);
      if (categoria) {
        setForm((prev) => ({ ...prev, categoria }));
      }
    }
  }, [item]);

  useEffect(() => {
    if (form.quantidade > 0)
      setForm((prev) => ({
        ...prev,
        valorUnitario: +(prev.valorTotal / prev.quantidade).toFixed(2),
      }));
  }, [form.quantidade, form.valorTotal]);
  useEffect(() => {
    store.propriedade && getInsumos();
  }, [store.propriedade]);
  async function getInsumos() {
    const insumos = await getThingsV2<Insumo>('/produto/', {
      propriedade: store.propriedade!.id,
      mostrar_todos: true,
    });
    setInsumos(insumos);
  }
  if (!sync) return null;
  return (
    <Modal onClose={handleClose} open={open}>
      <ModalHeader>{item ? 'Editar' : 'Novo'} Item</ModalHeader>
      <ModalBody style={{ width: 500 }}>
        <Box width="100%">
          <Select
            value={form.insumo}
            placeholder="Nome do insumo"
            onChange={(e: any) => {
              const result = insumos?.filter((insumo) => {
                return insumo.nome === e.label;
              });
              const unidade = result![0].tipo_unidade;
              setForm((prev) => ({ ...prev, insumo: e, unidade }));
            }}
            options={insumos.map((insumo) => ({ label: insumo.nome, value: insumo.id, tipo: insumo.tipo_unidade }))}
          />
          <Select
            disabled
            value={form.unidade ? { label: form.unidade, value: 'unidade' } : null}
            placeholder="Unidade"
            options={[
              { label: 'UN', value: 'UN' },
              { label: 'KG', value: 'KG' },
              { label: 'MT', value: 'MT' },
            ]}
          />
          {/* <Select
            placeholder="Categoria"
            value={form.categoria}
            onChange={(e: any) => setForm((prev) => ({ ...prev, categoria: e }))}
            options={categoriasOptions}
          /> */}
          <TextField
            value={form.descricao}
            onChange={updateFormEvent}
            name="descricao"
            label="Descrição"
            inputProps={{ maxLength: 100 }}
          />
          <InputNumero
            value={form.valorTotal}
            onChange={(value) => setForm((prev) => ({ ...prev, valorTotal: value }))}
            precision="2"
            label="Valor Total"
          />
          <InputNumero
            value={form.quantidade}
            onChange={(value) => setForm((prev) => ({ ...prev, quantidade: value }))}
            precision="3"
            label="Quantidade"
          />
          <InputNumero
            value={form.valorUnitario}
            disabled
            onChange={(value) => setForm((prev) => ({ ...prev, valorUnitario: value }))}
            precision="2"
            label="Valor Unitário"
          />

          <Flex>
            <Botao onClick={handleClose} variant="contained" cor="#FC7467">
              Cancelar
            </Botao>
            <Botao onClick={handleSubmit} variant="contained" cor="#00C853">
              Salvar
            </Botao>
          </Flex>
        </Box>
      </ModalBody>
    </Modal>
  );
}
